import {
    Camera,
    ChevronDown,
    ChevronUp,
    Compass,
    LayoutList,
    Plus,
    Settings2,
    Trash2,
    Calendar,
} from "lucide-react";
import { HelpContentContainer } from ".";
import { ModalHeader } from "@/components/Modal/ModalHeader";
import MenuGuideTable from "@/components/Modals/HelpGuideModal/MenuGuideTable";
import { AppText } from "@/components/Text/AppText";

interface HelpGuideContextMenusProps {
    onClose: () => void;
}

const profileSectionContextMenuItems = [
    {
        icon: <Camera size={16} />,
        name: "Add/Edit Photo",
        description: "Add or edit a photo to the profile section.",
    },
    {
        icon: <Settings2 size={16} />,
        name: "Section Settings",
        description:
            "Open the section settings menu in the sidebar for the profile section.",
    },
    {
        icon: <LayoutList size={16} />,
        name: "Section Presets",
        description:
            "Open the section presets menu to adjust the layout of the profile section.",
    },
];

const otherSectionContextMenuItems = [
    {
        icon: <Plus size={16} />,
        name: "New Item",
        description: "Add a new item to the section.",
    },
    {
        icon: <ChevronUp size={16} />,
        name: "Move Item Up",
        description: "Move the selected item up in the section.",
    },
    {
        icon: <ChevronDown size={16} />,
        name: "Move Item Down",
        description: "Move the selected item down in the section.",
    },
    {
        icon: <Settings2 size={16} />,
        name: "Section Settings",
        description:
            "Open the section settings menu in the sidebar for the selected section.",
    },
    {
        icon: <Compass size={16} />,
        name: "Section Assistant",
        description:
            "Open the section assistant menu in the sidebar for the selected section.",
    },
    {
        icon: <Calendar size={16} />,
        name: "Date Picker",
        description:
            "If the section you are editing contains a date, you can click on the calendar icon or the date field to open the date picker.",
    },
    {
        icon: <LayoutList size={16} />,
        name: "Section Presets",
        description:
            "Open the section presets menu to adjust how dates and locations are displayed. This will apply to all sections in the resume.",
    },
    {
        icon: <Trash2 size={16} />,
        name: "Delete Section",
        description: "Delete the selected section or item.",
    },
];

export const HelpGuideContextMenus = ({
    onClose,
}: HelpGuideContextMenusProps) => {
    return (
        <div>
            <ModalHeader
                title="Context Menus"
                onClose={onClose}
            />
            <HelpContentContainer>
                <AppText variant="regular">
                    Across the builder there are several types of context menus
                    available.
                </AppText>
                <AppText
                    variant="contextheading"
                    className="py-2 text-neutral-700"
                >
                    Section and Section Item Context Menus
                </AppText>
                <AppText variant="regular">
                    When you select (click on) a section, a floating menu will
                    appear, offering a variety of shortcuts to enhance your
                    editing experience. Depending on the section the menu you
                    will see will differ.
                </AppText>
                <AppText
                    variant="regular"
                    className="pt-4 !font-semibold text-neutral-700"
                >
                    Profile Section Context Menu
                </AppText>
                <AppText variant="regular">
                    Hovering over the profile section will display the profile
                    section context menu where you can customise the content
                    displayed in the profile section. The following actions are
                    available:
                </AppText>
                <MenuGuideTable items={profileSectionContextMenuItems} />
                <AppText
                    variant="regular"
                    className="pt-4 !font-semibold text-neutral-700"
                >
                    All Other Section Context Menus
                </AppText>
                <AppText variant="regular">
                    Selecting a section or a section item other than the profile
                    section will display the section context menu. The following
                    actions are available:
                </AppText>
                <MenuGuideTable items={otherSectionContextMenuItems} />
            </HelpContentContainer>
        </div>
    );
};
